export default __webpack_public_path__ + "static/media/morocco6.cfb230c7.jpg";